import styled from 'styled-components'

export const Container = styled.div`
  font-size: 12px;
  line-height: 14px;
  color: #666666;

  margin-bottom: 31px;

  a {
    color: #666666;
    text-decoration: none;
    margin-right: 5px;

    &:before {
      content: '/';
      margin-right: 5px;
    }

    &:first-child {
      &:before {
        content: '';
        margin-right: 0px;
      }
    }
  }
`
